module.exports = __webpack_public_path__ + "img/fopeaInsultosX5.81bf5525.jpg";